<template>
<div class="container">
    <div class="row">
        <div class="col-12 journey-page-section" v-if="viewingDetails">
            <div class="journey-page">
                <a class="skip-main" href="#main">Skip to main content</a>
                <div class="">
                    <div class="sticky-bar bg-white" ref="stickyBar">
                        <hr class="my-0">
                        <div class="container ">
                            <div class="row">
                                <div class="col-12 my-4 d-flex align-items-center ">
                                    <div class="viewing-buttons d-none d-md-block">
                                        <p class="d-inline mr-3">Viewing:</p>
                                        <button @click="scrollToJourneyDetails()" :class="getViewingButtonClass('details')" :type="'details'" class="btn mr-2 "> Journey Details </button>
                                        <button @click="scrollToElementMap()"  :class="getViewingButtonClass('map')" :type="'map'" class="btn mr-2"> Map of journey </button>
                                        <button @click="scrollToElementSteps()"  :class="getViewingButtonClass('step-by-step')" :type="'step-by-step'" class="btn mr-2"> Step by step guide </button>
                                    </div>
                                    <button @click="print" class="btn btn-outline-secondary ml-auto mr-auto mr-md-0 px-4 py-2 d-none d-md-block">
                                        <svg-icon aria-label="print button icon" name="print"></svg-icon>
                                        Print
                                    </button>
                                </div>
                            </div>
                        </div>
                        <hr class="my-0">
                    </div>
                    <div v-if="this.brand ==='nhs'" class="row bg-light-gray px-6 py-3 align-items-center mt-4 rounded-10 mx-0">
                        <div class="col-lg-7">
                            <h2>We’ve based your return on an appointment length of: </h2>
                            <p>You can change this to recalculate your return journey</p>
                        </div>
                        <div class="col-lg-3 mt-3 mt-lg-0 ">
                            <vue-select class="bg-white"
                                id="selectTime"
                                :searchable="false"
                                :options="option.hours"
                                v-model="selectedTime"
                                @input="setSelected">
                            </vue-select>
                        </div>
                        <div class="col-lg-2 mt-3 mt-lg-0">
                            <button class="btn btn-primary update-btn w-100" :disabled="!this.hasChanged" type="button"  @click="updateJourney"> Update </button>
                        </div>
                    </div>
                    <div id="details" class="row my-4 journey-details details" ref='details'>
                        <div class="col-12">
                            <app-success :success="defaultSuccess" aria-invalid='true'></app-success>
                        </div>
                        <div class="ml-1 ml-md-0 col-12 row">
                            <div class="col-md-4 col-12 " style="padding-left: 0px;">
                                <h1>Journey Details</h1>
                            </div>
                            <div class="col-md-8 col-12 d-flex flex-column flex-md-row " style="padding-left: 0px; padding-right: 0px;">

                                <div class="col-md-4 px-0 px-md-2">
                                    <b-button v-if="hasDrtOperator" class="full-green-btn mr-md-2 mb-2" @click="openDrtBookingWebsite">
                                        <span>More information<svg-icon class="arrow-right-find" name="forward"></svg-icon></span>
                                    </b-button>
                                </div>

                                <button @click="print" class="btn btn-outline-secondary ml-auto mr-auto mr-md-0 px-4 py-2 d-md-none  w-100 mb-2 d-block">
                                        <svg-icon aria-label="print button icon" name="print" height="31" width="auto"></svg-icon>
                                        Print Journey
                                    </button>

                                <button data-toggle="modal" data-target="#breakdown" class="btn btn-outline-secondary mr-md-2 mb-2">
                                    <svg-icon name="pricing" height="31" width="auto" />
                                    Pricing Breakdown
                                </button>

                                <button v-if="isTransit" data-toggle="modal" data-target="#paymentMethods" class="btn btn-outline-secondary mr-md-2 mb-2">
                                    <svg-icon name="currency-pound" height="31" width="auto" />
                                    Accepted payment methods
                                </button>

                                <button v-if="showLocalTaxiOperators" data-toggle="modal" data-target="#taxi" class="btn btn-outline-secondary mb-2">
                                    <svg-icon name="taxi" height="31" width="auto" />
                                    Find local taxi operators
                                </button>

                            </div>
                            <div class="col-12">
                                <loading :isLoading="isLoading"></loading>
                            </div>
                        </div>

                        <div class="modal fade" id="breakdown" tabindex="-1" role="dialog" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered" role="document">
                                <div class="modal-content">
                                    <div class="modal-header d-flex justify-content-between mx-4 py-2 align-items-center">
                                        <h5 class="modal-title">Pricing Breakdown</h5>
                                        <a href="javascript:void(0)" data-dismiss="modal" aria-label="Close">
                                            Close
                                        </a>
                                    </div>
                                    <div class="modal-body p-0">
                                        <div class="col-12">
                                            <Pricing></Pricing>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="modal fade" id="paymentMethods" tabindex="-1" role="dialog" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered" role="document">
                                <div class="modal-content">
                                    <div class="modal-header d-flex justify-content-between mx-4 py-2 align-items-center">
                                        <h5 class="modal-title">Payment Methods</h5>
                                        <a href="javascript:void(0)" data-dismiss="modal" aria-label="Close">
                                            Close
                                        </a>
                                    </div>
                                    <div class="modal-body p-0">
                                        <div class="col-12">
                                            <Payments></Payments>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="modal fade" id="taxi" tabindex="-1" role="dialog"  aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title col-6 " >Local Taxi operators</h5>
                                        <div class="col-6">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <p class="close-modal-button" aria-hidden="true">Close</p>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="modal-body mb-4 col-12">
                                        <div class="col-6 float-left">
                                            <taxis :journey-type="journeyType"></taxis>
                                        </div>

                                        <div class="col-6 float-right taxi-modal-text pt-3">
                                            <p> If you call a taxi operator, tell them where and when you want to be picked up and dropped off. The price displayed in your journey plan is an <strong>estimate only.</strong></p>
                                            <p> Calls are charged at your communication provider rate. Check with your provider before you dial </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div>
                            <journey-details v-if="!isLoading" :journey-type="journeyType" @change-type="handleJourneyTypeChange" />
                        </div>
                    </div>
                    <div class="row mt-5 map-of-journey" ref='map'>
                        <div class="col-md-4 col-sm-12">
                            <h1>Map of journey</h1>
                        </div>
                        <div class="col-md-8 col-sm-12 col-xs-12 text-right">
                            <p class="d-md-inline-block mr-3 d-none d-md-inline">Show on map</p>
                            <div class="showing d-md-inline-block ">
                                <div class="input-group">
                                    <div v-if="brand === 'nhs'" style="display:none" class="input-group-prepend">
                                        <label class="input-group-text bg-white" for="map-filter">Showing</label>
                                    </div>
                                    <div v-else class="input-group-prepend">
                                        <label class="input-group-text bg-white" for="map-filter">Showing</label>
                                    </div>
                                    <select class="d-inline-block flex-grow-1" v-model="mapFilter.selected" id="map-filter">
                                        <option v-for="(option, index) in filters" :key="index" :value="option.slug">
                                            <span class="ml-1">{{ option.name }}</span><span v-if="option.count">({{ option.count }})</span>
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <loading :isLoading="isLoading"></loading>
                            <journey-map class="mt-3" v-if="!isLoading"  @change-type="handleJourneyTypeChange" :type="journeyType"></journey-map>
                        </div>
                    </div>
                    <div v-if="brand==='kcc'" class="p-3 mt-4" style="background: #F2F2F2;">
                        <p>For further information on a specific toilet location including opening hours and accessibility, please click the toilets icon for that location. All toilet data is provided by
                            <a href="https://www.toiletmap.org.uk/about">https://www.toiletmap.org.uk/about.</a></p>
                    </div>
                    <div class="row">
                        <div class="col-12 mt-5 steps-journey" ref='stepByStep'>
                            <h1>Step-by-step guide</h1>
                            <loading :isLoading="isLoading"></loading>
                            <div v-if="!isLoading" class="row mb-5">
                                <div class="col-12 mb-3">
                                    <hr>
                                </div>
                                <div class="col-lg-7">
                                    <stage-steps :journey="currentJourney" @showDetails="showDetails"></stage-steps>
                                </div>
                                <div v-if="this.brand === 'nhs' " class="col-lg-4 col-sm-12 col-md-4 offset-md-1 mb-3 mt-3 bg-white">
                                    <h2>Alternative return option</h2>
                                    <p>Select below to see an alternative return journey should your appointment end earlier or later than expected:</p>
                                    <button type="button" class="btn btn-primary px-4 py-3 mt-3 rounded-pill d-flex align-items-center justify-content-center w-100" @click="alternativeReturn(true)">
                                        <h3 class="d-inline mb-0">Show me an early return option</h3>
                                        <svg-icon aria-labelledby="arrow right icon" color="white" class="ml-3" name="arrow-right" width="24" height="auto"></svg-icon>
                                    </button>
                                    <button type="button" class="btn btn-primary px-4 py-3 mt-3 rounded-pill d-flex align-items-center justify-content-center w-100" @click="alternativeReturn()">
                                        <h3 class="d-inline mb-0">Show me a later return option</h3>
                                        <svg-icon aria-labelledby="arrow right icon" color="white"  class="ml-3" name="arrow-right" width="24" height="auto"></svg-icon>
                                    </button>
                                </div>
                            </div>
                            <p></p>
                        </div>
                    </div>
                    <div v-if="brand==='kcc' && gotWalkingSteps" class="p-3 mb-5" style="background: #F2F2F2;">
                        <p>We do our best to recommend safe walking routes however there may be occasions where the route suggested is not suitable, especially for those with a disability.
                             Please always use caution when following directions</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 journey-page-section" v-if="!viewingDetails">
            <nav class="navbar  row navbar-journey-details px-4">
                <div class="container">
                    <a class="navbar-brand" @click="goToHome()" href="#">
                        <div v-if="this.brand === 'goAbz'">
                            <img :src="require( `../assets/${this.logo}`)" alt='brand logo'  width="60%"/>
                        </div>
                        <div v-else-if="this.brand != 'kcc'">
                            <img :src="require( `../assets/${this.logo}`)" alt='brand logo' />
                        </div>
                    </a>
                    <a class="back-to-journey-details-text" href @click.prevent="showJourney">
                    <strong>&lt; Back to journey details</strong>
                    </a>
                </div>
            </nav>
            <stage-details @goBack="showJourney" :stage="selectedStage"> </stage-details>
            <div class="container px-4 mb-5">
                <div class="row">
                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 mt-4">
                        <h1>Stage steps</h1>
                        <hr>
                    </div>
                </div>
                <div class="row ">
                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                        <stage-directions
                            @navigate="navigateStage"
                            :step="selectedStage"
                            :showNext="showNext()"
                            :showPrevious="showPrevious()">
                        </stage-directions>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showPois">
            <div>
                <loading :isLoading="isLoading"></loading>
            </div>
            <div class="col-11  back-grey overflow-auto pois-container" v-if="!isLoading">
                <Pois :journey-type="journeyType" @change-type="handleJourneyTypeChange"></Pois>
            </div>
            <div class="col-1  arrow-box" @click="swipeRight">
                <div class="mx-auto">
                    <div class="arrowed">
                        <div class="arrow-border">
                            <svg-icon class="arrow-right" name="forward"></svg-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import JourneyDetails from '@/components/JourneyDetails.vue'
import moment from 'moment'
import JourneyMap from '@/components/JourneyMap.vue'
import Pricing from '@/components/PricingBreakdown.vue'
import Payments from '@/components/PaymentMethodsBreakdown.vue'
import Taxis from '@/components/Taxis.vue'
import StageDetails from '@/components/StageDetails.vue'
import StageDirections from '@/components/StageDirections.vue'
import StageSteps from '@/components/StageSteps.vue'
import Pois from '@/components/ShowMorePois.vue'
import {
    mapGetters, mapActions, mapState, mapMutations,
} from 'vuex'
import mutationsMapping from '@/store/mutations-mapping'
import AppSuccess from '@/components/AppSuccess.vue'
import _ from 'lodash'

const whitelabel = require('../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {
    name: 'journey',
    components: {
        JourneyDetails,
        JourneyMap,
        StageDetails,
        StageDirections,
        StageSteps,
        Pricing,
        Payments,
        Taxis,
        AppSuccess,
        Pois,
    },
    data() {
        return {
            selected: '',
            viewingDetails: true,
            journeyType: 'depart',
            selectedStage: {},
            selectedStageIndex: null,
            showingReturn: false,
            showDepartStepsOffset: 1000,
            showReturnStepsOffset: 1000,
            logo: whitelabel.navbarLogo,
            brand: whitelabel.brand,
            selectedTime: { label: '1 hour', value: 60, disabled: false },
            hasChanged: false,
            option: {
                hours: [
                    { label: '30 minutes', value: 30, disabled: false },
                    { label: '1 hour', value: 60, disabled: false },
                    { label: '1 hour 30 minutes', value: 90, disabled: false },
                    { label: '2 hours', value: 120, disabled: false },
                    { label: '2 hours 30 minutes', value: 150, disabled: false },
                    { label: '3 hours', value: 180, disabled: false },
                ],
            },
            showPois: whitelabel.showPois,
        }
    },
    computed: {
        ...mapGetters([
            'getJourneyById',
            'steps',
            'getMapFilters',
        ]),
        ...mapState([
            'currentJourney',
            'isLoading',
            'origin',
            'destination',
            'arriveDate',
            'arriveTime',
            'arriveDateAndTime',
            'railcardType',
            'hasAccessToCar',
            'hasConcessionaryPass',
            'mapFilter',
            'searchQuery',
            'returnTime',
            'defaultSuccess',
        ]),
        filters() {
            return this.getMapFilters(this.journeyType)
        },
        steps() {
            return this.currentJourney.return ? [...this.currentJourney.depart.steps, ...this.currentJourney.return.steps] : [...this.currentJourney.depart.steps]
        },
        selectedTimeLabel() {
            return _.find(this.option.hours, (i) => i.value === this.appointmentLength)
        },
        taxis() {
            return this.currentJourney.return ? [...this.currentJourney.depart.taxis, ...this.currentJourney.return.taxis] : [...this.currentJourney.depart.taxis]
        },
        pois() {
            return this.currentJourney.return ? [...this.currentJourney.depart.pois, ...this.currentJourney.return.pois] : [...this.currentJourney.depart.pois]
        },
        showLocalTaxiOperators() {
            return this.currentJourney ? this.currentJourney.depart.stages[0] === 'taxi' : false
        },
        hasDrtOperator() {
            return this.currentJourney && this.currentJourney.drt_operator ? this.currentJourney.drt_operator : false
        },
        isTransit() {
            return this.currentJourney ? this.currentJourney.transport_mode === 'transit' : false
        },
        gotWalkingSteps() {
            return this.steps.some((step) => step.type === 'walk');
        },
    },
    methods: {
        ...mapActions([
            'retrieveSingleJourney',
            'updateReturnTime',
        ]),
        ...mapMutations(mutationsMapping),
        navigateStage(type) {
            if (type === 'forward') {
                this.selectedStageIndex += 1
            } else {
                this.selectedStageIndex -= 1
            }
            this.selectedStage = this.steps[this.selectedStageIndex]
            window.scrollTo(0, 0)
        },
        showDetails(step, index) {
            window.scrollTo(0, 0)
            this.viewingDetails = false
            this.selectedStage = step
            this.selectedStageIndex = index
        },
        showJourney() {
            this.viewingDetails = true
            this.selectedStage = {}
            this.selectedStageIndex = 0
        },
        showNext() {
            return this.steps.length >= this.selectedStageIndex + 2
        },
        showPrevious() {
            return this.selectedStageIndex > 0
        },
        fetchJourney() {
            const currentJourney = this.getJourneyById(this.$route.params.journeyId)
            if (currentJourney) {
                this.setCurrentJourney(currentJourney.journey)
            } else if (this.$route.query.show) {
                this.retrieveSingleJourney({
                    hash: this.$route.params.hash,
                    journeyID: this.$route.params.journeyId,
                    showCurrentJourney: true,
                })
            } else {
                this.retrieveSingleJourney({
                    hash: this.$route.params.hash,
                    journeyID: this.$route.params.journeyId,
                })
            }
        },
        handleJourneyTypeChange(type) {
            this.journeyType = type
        },
        toggleJourneyType(type) {
            this.showingReturn = type
        },
        goToHome() {
            this.$router.push({ name: 'Home' })
        },
        openDrtBookingWebsite() {
            window.open(this.currentJourney.drt_operator.booking_website, '_blank');
        },
        setSelected(value) {
            if (value.value === this.selectedTime.value) {
                // this.selectedTime.disabled = true
                this.hasChanged = true
            } else {
                this.hasChanged = false
            }
        },
        getUpdatedTime() {
            /* arriveDateAndTime might not be available at page refresh - use return departure_at instead */
            const returnTime = moment(this.currentJourney.return.departure_at, 'HH:mm')
            return returnTime.add(this.selectedTime.value, 'minutes').format('YYYY/MM/DD HH:mm:ss')
        },
        updateJourney() {
            // this.hasChanged = false
            const updatedTime = this.getUpdatedTime()
            this.clearResults();

            this.updateReturnTime({
                hash: this.$route.params.hash,
                params: { return_time: updatedTime },
                router: this.$router,
            })
        },
        alternativeReturn(early = false) {
            const updatedTime = moment(this.searchQuery.return_time, 'HH:mm')
            console.log(updatedTime)
            if (early) {
                updatedTime.subtract(30, 'minutes')
            } else {
                updatedTime.add(30, 'minutes')
            }
            this.clearResults()
            this.updateReturnTime({
                hash: this.$route.params.hash,
                params: { return_time: updatedTime.format('YYYY/MM/DD HH:mm:ss') },
                router: this.$router,
            })
        },
        getViewingButtonClass(type) {
            if (this.selected === type) {
                return 'btn-outline-primary'
            }

            return 'btn-outline-secondary'
        },
        scrollToElementMap() {
            this.selected = 'map'
            const el = this.$el.getElementsByClassName('map-of-journey')[0]

            if (el) {
                el.scrollIntoView()
            }
        },
        scrollToElementSteps() {
            this.selected = 'step-by-step'
            const el = this.$el.getElementsByClassName('steps-journey')[0]

            if (el) {
                el.scrollIntoView()
            }
        },
        scrollToJourneyDetails() {
            this.selected = 'details'
            const el = this.$el.getElementsByClassName('journey-details')[0]

            if (el) {
                el.scrollIntoView()
            }
        },
        handleScroll() {
            if (this.$refs.map !== undefined && this.$refs.map.offsetTop) {
                const posWithStickyBarOffset = window.scrollY + this.$refs.stickyBar.offsetHeight + this.$refs.stickyBar.getBoundingClientRect().top

                if (posWithStickyBarOffset < this.$refs.map.offsetTop) {
                    this.selected = 'details'
                    this.getViewingButtonClass();
                } else if (posWithStickyBarOffset > this.$refs.map.offsetTop && posWithStickyBarOffset < this.$refs.stepByStep.offsetTop) {
                    this.selected = 'map'
                    this.getViewingButtonClass();
                } else if (posWithStickyBarOffset > this.$refs.stepByStep.offsetTop) {
                    this.selected = 'step-by-step'
                    this.getViewingButtonClass();
                }
            }
        },
        swipeRight() {
            const el = this.$el.getElementsByClassName('pois-container')[0]
            el.scrollBy({
                top: 0,
                left: +500,
                behavior: 'smooth',
            })
        },
        print() {
            window.print()
        },
    },
    mounted() {
        this.selectedTime = this.selectedTimeLabel
    },
    created() {
        if (this.$route.params.journeyType && ['depart', 'return'].includes(this.$route.params.journeyType)) {
            this.journeyType = this.$route.params.journeyType
        }

        this.fetchJourney()
    },
}
</script>
